const log = {
    invalid_type: 'El tipo de registro es inválido.',
};
export default Object.freeze(log);
